import {
  DIAGNOSTIC_TOOL_URL,
  PRODUCT_ID,
  REMOTE_CONTROL_URL,
} from "common-ui-components/components/utils/Config";
import { normalizeDeviceOs } from "app/common/config/deviceToolsConfig";

export const openDiagnosticTool = ({ deviceId, toolName, os }) => {
  if (!toolName || !os) {
    throw new Error("toolName and os are required to open a diagnostic tool");
  }

  const params = new URLSearchParams({
    deviceId,
    productId: PRODUCT_ID,
    toolName,
    os,
  });

  return window.open(
    `${DIAGNOSTIC_TOOL_URL}?${params.toString()}`,
    "diagnostic-tools-viewer",
  );
};

export const openRemoteControlViewer = ({
  deviceId,
  type = "rc",
  systemUserName,
  os,
}) => {
  const normalizedOs = normalizeDeviceOs(os);
  if (!normalizedOs) {
    throw new Error("A supported operating system is required to open remote control");
  }

  const params = new URLSearchParams({
    id: deviceId,
    type,
    productId: PRODUCT_ID,
    os: normalizedOs,
  });

  if (systemUserName) params.append("systemUserName", systemUserName);

  return window.open(`${REMOTE_CONTROL_URL}?${params.toString()}`);
};
